import React, {Component} from 'react';
import Errors from '../common/Errors'
import {Link} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import * as AppConstant from '../common/AppConstant'
import {Redirect} from 'react-router-dom';
import RequiredAstrisk from '../common/RequiredAstrisk'

class Organization extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dateFormats :[],
            countries:null,
            organization:{

            },
            loggedInUser:{},
            address : {},
            showLoader:false,
            nameError:null,
            street1Error:null,
            street2Error:null,
            cityError:null,
            stateError:null,
            countryCodeError:null,
            redirectToErrorPage:false,
            redirectToForbiddenPage:false,
            redirectToDashBoard:false,
            dateFormatError:null,
            disabledButton:false,
            logo:null,
            apiStatus:{
                isError:false,
                message:''
            },
            showDiv:false,
            rediretPage: ''
        }

        this.fetchGeneralData = this.fetchGeneralData.bind(this);
        this.fetchOrganization = this.fetchOrganization.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showLogoUploadDiv = this.showLogoUploadDiv.bind(this);
        this.handleChangeLogo = this.handleChangeLogo.bind(this);
        this.submitUpdateLogo = this.submitUpdateLogo.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
        this.validator = new SimpleReactValidator({autoForceUpdate: this,element: false});
    }
    handleChange(event) {
        const {organization} = this.state
        const {address} = organization;
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const id = target.id;
        console.log(name+" === "+value+" ===  "+id+"====   "+address+"===")
        if(id.indexOf("address") !== -1){
            address[name] = value
        }else if(id === 'logo') {
            let file = event.target.files[0];
            console.log(event.target.files[0].size)
            this.setState({
                logo: file
            });
        }else{
            organization[name] = name === 'enableSignWithIp' ? event.target.checked : value;
        }
        this.setState({organization: organization});
    }
    componentDidMount(){
        sessionStorage.removeItem("childLinkName");
        sessionStorage.setItem("childLinkName","orgNav");
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchGeneralData();
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    fetchGeneralData() {
        fetch(this.props.api + '/utility/dateformatAndCountryList', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else {
                    this.setState({dateFormats: json.dateFormat, countries: json.countries}, function () {this.fetchOrganization()});
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    fetchOrganization() {
        this.setState({showLoader:true})
        fetch(this.props.api + '/organization', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                    this.setState({showLoader: false, redirectToForbiddenPage: true});
                } else {
                    this.setState({organization: json, address: json.address});
                    this.setState({showLoader: false})
                }
            })
            .catch(error => {
                this.setState({showLoader:false});
                console.log(error);
            });

    }

    handleSubmit(event) {
        event.preventDefault();
        console.log(this.validator.allValid());
        if (this.validator.allValid()) {
            this.setState({showLoader:true});
            let {organization} = this.state;
            organization["address"] = this.state.address;
            fetch(this.props.api + '/organization', {
                method: 'PUT',
                mode: 'cors',
                body: JSON.stringify(this.state.organization),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    const {apiStatus}  = this.state;
                    if(json && json.isError === false){
                        apiStatus.isError=false;
                        apiStatus.message = json.message;
                    }else{
                        apiStatus.isError=true;
                        apiStatus.message=json.message;
                        apiStatus.messages=json.messages;
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        }
                    }
                    this.setState({showLoader: false, disabledButton: false, apiStatus: apiStatus, redirectToDashBoard:(apiStatus.isError === false ? true : false)})
                })
                .catch(error => {
                    const {apiStatus}  = this.state;
                    apiStatus.isError=true;
                    apiStatus.message = error;
                    this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
                    console.log(error);
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    showLogoUploadDiv(){
        this.setState({showDiv:!this.state.showDiv})
    }

    handleChangeLogo(e){
        this.setState({logo: e.target.files[0]});
    }

    submitUpdateLogo(){
        const formData = new FormData();
        this.setState({showLoader:true})
        formData.append('logo', this.state.logo);
        fetch(this.props.api + '/organization/updateLogo', {
            method: 'POST',
            body: formData,
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            const {apiStatus}  = this.state;
            if(json && json.isError === false){
                apiStatus.isError=false;
                apiStatus.message = json.message
                this.setState({disabledButton: false, apiStatus: apiStatus, showDiv: true, showLoader: false, redirectToDashBoard:(apiStatus.isError === false ? true : false)})
            }else{
                apiStatus.isError=true;
                apiStatus.message = json.message
                this.setState({disabledButton: false, apiStatus: apiStatus, showDiv: true, showLoader: false})
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                }
            }
        })
        .catch(error => {
            const {apiStatus}  = this.state;
            apiStatus.isError=true;
            apiStatus.message = error
            this.setState({disabledButton: false, apiStatus: apiStatus, showDiv: true, showLoader: false})
            console.log(error);
        });
    }

    render() {
        const dateFormat = this.state.dateFormats && this.state.dateFormats.map((data) =>{
                return <option key={data} value={data}>{data}</option>
            })
        let _this = this;
        const countries = this.state.countries && Object.keys(this.state.countries).map(function (key) {
                return <option key={key} value={key}>{_this.state.countries[key]}</option>
            })
        return (
            <React.Fragment>
                <div className="wrapper animated fadeInRight">
                    <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                          redirectToErrorPage={this.state.redirectToErrorPage}
                                          redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                    {
                        (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (<Redirect to={'/msg/'+this.state.apiStatus.message}/>) : null
                    }
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="dashboard-table-wrap">
                                <div className="heading-wrapper clearfix">
                                    <p className="m-t-xs">{_this.props.msg('organization.label.header')}</p>
                                </div>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <div className="table-box table-responsive p-m" style={{textAlign:"center",minHeight:'490px'}}>
                                    <Errors errorObject={this.state.apiStatus}/>
                                    <form onSubmit={this.handleSubmit} className="form-horizontal">
                                        <div className="col-md-12">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.name')}
                                                        <RequiredAstrisk/></label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" onChange={this.handleChange}
                                                               id="name" name="name" value={this.state.organization.name?this.state.organization.name:''}/>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('name', this.state.organization.name, 'required|min:3|max:50')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.domainPrefix')}
                                                        <RequiredAstrisk/></label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" id="domainPrefix"
                                                               name="domainPrefix" readOnly={true}  onChange={this.handleChange}
                                                               value={this.state.organization.domainPrefix?this.state.organization.domainPrefix:''}/>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.date')}
                                                        <RequiredAstrisk/></label>
                                                    <div className="col-lg-10">
                                                        <select className="form-control"
                                                                name="dateFormat" onChange={this.handleChange}
                                                                value={this.state.organization.dateFormat?this.state.organization.dateFormat?this.state.organization.dateFormat:'':''}>
                                                            <option value="">-Select Date Format-</option>
                                                            {dateFormat}
                                                        </select>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('Date Format', this.state.organization.dateFormat, 'required|in:dd/MM/yyyy,MM/dd/yyyy,yyyy-MM-dd')}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<div className="form-group row">
                                                    <label className="col-lg-5 control-label"
                                                           style={{textAlign:'left'}}>Enable Signature With IP and Date</label>

                                                    <div className="col-lg-3">
                                                        <input
                                                            type="checkbox" id="enableSignWithIp" name="enableSignWithIp"
                                                            checked={this.state.organization.enableSignWithIp} style={{textAlign:'left',margin: '13px 0 0'}}
                                                            onChange={this.handleChange}/>
                                                        <span className="tooltiphover" style = {{padding: '5px'}} data-toggle="tooltip" data-placement="right" title="Check to create recipient's signature with IP and current date">
                                                        <i className="fa fa-question-circle"></i>
                                                        </span>
                                                    </div>
                                                </div>*/}
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.street1')}</label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" id="address.street1" onChange={this.handleChange}
                                                               name="street1" value={this.state.organization.address?this.state.organization.address.street1?this.state.organization.address.street1:'':''}/>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('street', this.state.address.street1, 'min:3|max:100')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.suitDept')}</label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" id="address.street2"
                                                               name="street2" onChange={this.handleChange}
                                                               value={this.state.organization.address?this.state.organization.address.street2?this.state.organization.address.street2:'':''}/>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('suit/dept.', this.state.address.street2, 'min:3|max:100')}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.city')}</label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" id="address.city"
                                                               name="city" onChange={this.handleChange}
                                                               value={this.state.organization.address?this.state.organization.address.city?this.state.organization.address.city:'':''}/>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('city', this.state.address.city, 'min:3|max:30')}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.state')}</label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" id="address.state"
                                                               name="state" onChange={this.handleChange}
                                                               value={this.state.organization.address?this.state.organization.address.state?this.state.organization.address.state:'':''}/>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('state', this.state.address.state, 'min:2|max:30')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.zipCode')}</label>
                                                    <div className="col-lg-10">
                                                        <input type="text" className="form-control" id="address.zip"
                                                               name="zip" onChange={this.handleChange}
                                                               value={this.state.organization.address?this.state.organization.address.zip?this.state.organization.address.zip:'':''}/>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('pincode', this.state.address.zip, 'max:10')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-2 control-label">{_this.props.msg('organization.label.country')}</label>
                                                    <div className="col-lg-10">

                                                        <select type="text" className="form-control" id="address.country"
                                                                name="countryCode" onChange={this.handleChange}
                                                                value={this.state.organization.address?this.state.organization.address.countryCode?this.state.organization.address.countryCode:'':''}>
                                                            <option value="">-Select-</option>
                                                            {countries}
                                                        </select>
                                                        <div style={{color:"red"}}>
                                                            {this.validator.message('country', this.state.address.countryCode, 'required')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="col-md-12">
                                                <div className="col-md-8">

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="col-lg-2 control-label"> <a style={{textDecoration:'underline'}} onClick={this.showLogoUploadDiv}>Change Logo</a></label>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{display:this.state.showDiv===false?'none':'block'}}>
                                            <div className="form-group">
                                                <label className="col-lg-2 control-label">{_this.props.msg('organization.label.uploadLogo')}</label>
                                                <div className="col-lg-10">
                                                    <input type="file" name="logo" id="logo"
                                                           className="form-control" accept="image/gif, image/jpeg, image/png"
                                                           onChange={this.handleChangeLogo}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group" style={{display:this.state.showDiv===false?'none':'block'}}>
                                            <div className="col-lg-offset-2 col-lg-10">
                                                <input className="btn btn-primary" type="button" value={_this.props.msg('form.label.updateLogo')} onClick={this.submitUpdateLogo}/>
                                            </div>
                                        </div>
                                        {/*style={{display:this.state.showDiv===true?'block':'none'}}*/}
                                        <div className="form-group">
                                            <div className="col-lg-offset-2 col-lg-10">
                                                <Link to="/" className="btn btn-white">{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                                <input className="btn btn-primary" type="submit" value={_this.props.msg('form.label.submit')} disabled={this.state.disabledButton===true}/>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>

        );
    }
}

export default Organization;



// WEBPACK FOOTER //
// ./src/components/organization/Organization.js